import React from 'react';
import {Switch, FormControlLabel} from '@mui/material';
import {styled} from '@mui/material/styles';

const CustomSwitch = styled(props => (
  <FormControlLabel
    control={
      <Switch
        {...props}
        sx={{m: 1}}
        disableRipple
        focusVisibleClassName=".Mui-focusVisible"
      />
    }
    label={props.label || ''}
  />
))(({theme}) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export default CustomSwitch;
